import { ref, onBeforeUnmount } from 'vue';

const getRecognitionCtor = () => {
  if (typeof window === 'undefined') return undefined;
  return window.SpeechRecognition || window.webkitSpeechRecognition;
};

export function useSpeechToText(lang) {
  const Ctor = getRecognitionCtor();
  const supported = Boolean(Ctor);

  const recognitionRef = ref(null);
  const isRecording = ref(false);
  const transcript = ref('');
  const interimTranscript = ref('');
  const error = ref(null);

  const stop = () => {
    recognitionRef.value?.stop();
  };

  const start = () => {
    if (!Ctor) {
      error.value = 'not-supported';
      return;
    }
    error.value = null;
    transcript.value = '';
    interimTranscript.value = '';

    const recognition = new Ctor();
    recognition.lang =
      lang || (typeof navigator !== 'undefined' ? navigator.language : 'en-US');
    recognition.continuous = false;
    recognition.interimResults = true;

    recognition.onresult = event => {
      let finalText = '';
      let interimText = '';
      for (let i = event.resultIndex; i < event.results.length; i++) {
        const result = event.results[i];
        if (result.isFinal) {
          finalText += result[0].transcript;
        } else {
          interimText += result[0].transcript;
        }
      }
      if (finalText) transcript.value += finalText;
      interimTranscript.value = interimText;
    };

    recognition.onerror = event => {
      error.value = event.error || 'unknown';
      isRecording.value = false;
    };

    recognition.onend = () => {
      isRecording.value = false;
      interimTranscript.value = '';
    };

    recognitionRef.value = recognition;
    try {
      recognition.start();
      isRecording.value = true;
    } catch {
      error.value = 'start-failed';
      isRecording.value = false;
    }
  };

  onBeforeUnmount(() => {
    recognitionRef.value?.abort();
  });

  return { supported, isRecording, transcript, interimTranscript, error, start, stop };
}
